import { Button, Text } from '@chakra-ui/react';
import React from 'react';
import {
  Link,
  useLocation,
  useResolvedPath,
  useParams,
} from 'react-router-dom';

import { DataPipeline } from '@finley-technologies/finley-types';

export const PipelineDetailsPageLink = ({
  meshRunId,
}: {
  meshRunId: DataPipeline.MeshRunId;
}) => {
  const params = useParams();
  const location = useLocation();
  const currentPath = location.pathname;

  // we render data-pipeline upload drawer from multiple places.
  // 1. home page for borrowers/capital providers
  // 2. data-pipeline/ page for admin dashboard and customer dashboard
  // 3. data-pipelines/details page for admin dashboard and customer dashboard
  // the path to details page will be different from the admin dashboard vs customer dashboard.
  const targetPath = params.organizationId
    ? `/organizations/${params.organizationId}/data-pipeline/details/${meshRunId}`
    : `/data-pipeline/details/${meshRunId}`;

  const destinationPath = useResolvedPath(targetPath);

  // Check if the current path matches the destination path
  // (that is if the upload drawer is opened from the pipeline details page)
  const isSamePage = currentPath === destinationPath.pathname;
  if (isSamePage) {
    // when viewing this from the pipeline run page, do not render link.
    return null;
  }

  // if we are navigating away from the `/data-pipeline/` page,
  // we want to pass the search params to the details page.
  // so that on the details page, we can navigate back and land with same filters.
  destinationPath.search =
    currentPath.includes('data-pipeline') && !currentPath.includes('details')
      ? location.search
      : '';

  return (
    <Button as={Link} to={destinationPath} variant="link" colorScheme="blue">
      View Pipeline
    </Button>
  );
};

export const PipelinesPageLink = ({
  onLinkClick,
}: {
  onLinkClick: () => void;
}) => {
  const params = useParams();

  // we render data-pipeline upload drawer from multiple places.
  // 1. home page for borrowers/capital providers
  // 2. data-pipeline/ page for admin dashboard and customer dashboard
  // 3. data-pipelines/details page for admin dashboard and customer dashboard
  // the path to details page will be different from the admin dashboard vs customer dashboard.
  const targetPath = params.organizationId
    ? `/organizations/${params.organizationId}/data-pipeline/`
    : `/data-pipeline/`;

  const destinationPath = useResolvedPath(targetPath);

  return (
    <Link to={destinationPath} onClick={onLinkClick}>
      <Text>View All Data Pipelines</Text>
    </Link>
  );
};
